import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { ChatServerMessage } from "../../xapp/ChatServerMessage";
import { ActionType } from "../ChatAction";

export function writeMessage(msg: ChatServerMessage, user: ChatUserInfo): ActionType {
    return {
        type: "synthetic",
        detail: {
            type: "write_msg",
            user,
            msg,
            timestamp: +new Date()
        }
    };
}